(() => {
  const normalise = (value) =>
    value
      .toLocaleLowerCase('nl')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

  const initialiseKnowledgeHub = (hub) => {
    if (hub.dataset.knowledgeReady === 'true') return;

    const input = hub.querySelector('[data-knowledge-search]');
    const items = Array.from(hub.querySelectorAll('[data-knowledge-item]'));
    const groups = Array.from(hub.querySelectorAll('[data-knowledge-group-section]'));
    const filters = Array.from(hub.querySelectorAll('[data-knowledge-filter]'));
    const status = hub.querySelector('[data-knowledge-status]');
    const emptyState = hub.querySelector('[data-knowledge-empty]');

    if (!input || !items.length) return;

    let activeGroup = 'bestand';

    const update = () => {
      const query = normalise(input.value);
      let visibleCount = 0;

      items.forEach((item) => {
        const group = item.closest('[data-knowledge-group-section]')?.dataset.knowledgeGroup;
        const matchesQuery = normalise(item.dataset.knowledgeSearchText).includes(query);
        const matchesGroup = query.length > 0 || activeGroup === 'all' || group === activeGroup;
        item.hidden = !(matchesQuery && matchesGroup);
        if (matchesQuery && matchesGroup) visibleCount += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-knowledge-item]:not([hidden])');
      });

      if (status) {
        status.hidden = query.length === 0;
        status.textContent = visibleCount === 1 ? '1 artikel gevonden' : `${visibleCount} artikelen gevonden`;
      }
      if (emptyState) emptyState.hidden = query.length === 0 || visibleCount !== 0;
    };

    input.addEventListener('input', update);
    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeGroup = filter.dataset.knowledgeFilter;
        filters.forEach((option) => {
          const active = option === filter;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-pressed', String(active));
        });
        update();
      });
    });

    hub.dataset.knowledgeReady = 'true';
    update();
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-knowledge-hub]').forEach(initialiseKnowledgeHub);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
